import { Constants } from '../shared/Constants';

/**
 * BadgeMappingBuilder Class
 */
export class BadgeMappingBuilder {
    constructor() {
        this._mappings = [];
        this._current = null;
        this._default = null;
    }

    when(value) {
        this._current = { val: value, txt: value, theme: null, icon: null };
        this._mappings.push(this._current);
        return this;
    }

    /**
     * Fallback mapping for values that do not match any `.when(...)`.
     * Without `.text()`, the raw cell value is shown.
     * @returns {this}
     */
    default() {
        this._current = { txt: null, theme: null, icon: null };
        this._default = this._current;
        return this;
    }

    text(label) {
        if (this._current) this._current.txt = label;
        return this;
    }

    withIcon(iconClass) {
        if (this._current) this._current.icon = iconClass;
        return this;
    }

    success() { if (this._current) this._current.theme = Constants.Theme.SUCCESS; return this; }
    warning() { if (this._current) this._current.theme = Constants.Theme.WARNING; return this; }
    danger() { if (this._current) this._current.theme = Constants.Theme.DANGER; return this; }
    info() { if (this._current) this._current.theme = Constants.Theme.INFO; return this; }
    primary() { if (this._current) this._current.theme = Constants.Theme.PRIMARY; return this; }
    secondary() { if (this._current) this._current.theme = Constants.Theme.SECONDARY; return this; }

    _getMappings() {
        return this._mappings;
    }

    _getDefault() {
        return this._default;
    }
}
